import { createProjectEntity } from "../../domain/entities/projectEntity";
import { calculateSummaryMetrics } from "../../domain/services/portfolioMetricsService";

export function getPortfolioOverview(portfolioRepository) {
  const projects = portfolioRepository.getProjects().map(createProjectEntity);
  const strategicAssets = portfolioRepository.getStrategicAssets();
  const summary = calculateSummaryMetrics(projects);

  return {
    projects,
    strategicAssets,
    summary,
  };
}
